export const AMBIENTE_PRODUCAO = process.env.REACT_APP_ENV === "prod";

export const NOME_PLATAFORMA = AMBIENTE_PRODUCAO
  ? "Concreto Engenharia"
  : "QualiInfra";

export const NOME_CLIENTE_DOCUMENTO = AMBIENTE_PRODUCAO
  ? NOME_PLATAFORMA
  : "_____________________________";

export const NOME_EMPRESA_LEGAL = AMBIENTE_PRODUCAO
  ? "CONCRETO ENGENHARIA E CONSTRUÇÕES LTDA"
  : NOME_CLIENTE_DOCUMENTO;

export const LOGO_AUTENTICACAO = AMBIENTE_PRODUCAO
  ? "/Images/logo-small2.png"
  : "/Images/logoSiteSAAS.png";

export const LOGO_RELATORIO_PADRAO = AMBIENTE_PRODUCAO
  ? "/Images/logo-small2.png"
  : "/Images/logo-relatorios-padrao.png";

export const LOGO_NAVEGACAO = AMBIENTE_PRODUCAO
  ? "/Images/logo5.png"
  : "/Images/logo-relatorios-clara.png";

export const LOGO_SELO = AMBIENTE_PRODUCAO
  ? "/Images/logoISO.png"
  : "/Images/logo-relatorios-padrao.png";

export const LOGO_MARCA_DAGUA = AMBIENTE_PRODUCAO
  ? `${process.env.PUBLIC_URL || ""}/Images/logo timbrando tansparente.png`
  : `${process.env.PUBLIC_URL || ""}/Images/logo-relatorios-padrao.png`;
